<template>
  <!-- 复制弹窗 -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.SelectSynchronizedFields')"
    :width="$selectByLang('500px','584px')"
    :close-on-click-modal="false"
  >
    <div>
      <fieldset>
        <legend>{{ $t('Message.SynchronizedFields') }}</legend>
        <div style="display: flex;flex-direction: row;padding-left: 30px;">
          <el-checkbox v-model="containerInfo.containerSize" no="ContainerSize" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.ContainerSize') }}</el-checkbox>
          <el-checkbox v-model="containerInfo.containerType" no="ContainerType" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.ContainerType') }}</el-checkbox>
          <el-checkbox v-model="containerInfo.containerNo" no="ContainerNo" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.ContainerNo') }}</el-checkbox>
          <el-checkbox v-model="containerInfo.containerWeight" no="ContainerWeight" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.ContainerWeight') }}</el-checkbox>
        </div>
        <div style="display: flex;flex-direction: row;padding-left: 30px;">
          <el-checkbox v-model="containerInfo.sealNo" no="SealNo" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.SealNo') }}</el-checkbox>
          <el-checkbox v-model="containerInfo.itemCount" no="itemCount" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.itemCount') }}</el-checkbox>
          <el-checkbox v-model="containerInfo.grossWeight" no="GrossWeight" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.GrossWeight') }}</el-checkbox>
          <el-checkbox v-model="containerInfo.cubage" no="Cubage" :style="$selectByLang('width: 64px','width: 85px')">{{ $t('SeaExport.Cubage') }}</el-checkbox>
        </div>
      </fieldset>
      <div style="word-wrap: break-word; white-space: normal;font-family: sans-serif;margin-bottom: 8px;margin-left: 24px">
        <span style="font-size: 12px;line-height: 18px">{{ $t('SeaExport.AttentionForSynchronizedContainer') }}</span>
      </div>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="close">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'SynchronizedFieldsWindow',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    defalutAllTrue: { type: Boolean, required: true },
    containerInfo: { type: Object, required: true, default: () => {} }
  },
  data() {
    return {
      innerVisible: false
    }
  },
  computed: {
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.init()
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
    this.init()
  },
  methods: {
    init() {
      if (this.defalutAllTrue) {
        this.containerInfo.containerSize = true
        this.containerInfo.containerType = true
        this.containerInfo.containerNo = true
        this.containerInfo.containerWeight = true
        this.containerInfo.sealNo = true
        this.containerInfo.itemCount = true
        this.containerInfo.grossWeight = true
        this.containerInfo.cubage = true
        this.containerInfo.hsCode = true
      } else {
        this.containerInfo.containerSize = LocalStorageUtilsNew.getConfiguration('SynchronizedContainerSize') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedContainerSize')
        this.containerInfo.containerType = LocalStorageUtilsNew.getConfiguration('SynchronizedContainerType') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedContainerType')
        this.containerInfo.containerNo = LocalStorageUtilsNew.getConfiguration('SynchronizedContainerNo') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedContainerNo')
        this.containerInfo.containerWeight = LocalStorageUtilsNew.getConfiguration('SynchronizedContainerWeight') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedContainerWeight')
        this.containerInfo.sealNo = LocalStorageUtilsNew.getConfiguration('SynchronizedSealNo') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedSealNo')
        this.containerInfo.itemCount = LocalStorageUtilsNew.getConfiguration('SynchronizedItemCount') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedItemCount')
        this.containerInfo.grossWeight = LocalStorageUtilsNew.getConfiguration('SynchronizedGrossWeight') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedGrossWeight')
        this.containerInfo.cubage = LocalStorageUtilsNew.getConfiguration('SynchronizedCubage') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedCubage')
        this.containerInfo.hsCode = LocalStorageUtilsNew.getConfiguration('SynchronizedHsCode') === '' ? true : LocalStorageUtilsNew.getConfiguration('SynchronizedHsCode')
      }
    },
    enterHandler() {
      LocalStorageUtilsNew.setConfiguration('SynchronizedContainerSize', this.containerInfo.containerSize)
      LocalStorageUtilsNew.setConfiguration('SynchronizedContainerType', this.containerInfo.containerType)
      LocalStorageUtilsNew.setConfiguration('SynchronizedContainerNo', this.containerInfo.containerNo)
      LocalStorageUtilsNew.setConfiguration('SynchronizedContainerWeight', this.containerInfo.containerWeight)
      LocalStorageUtilsNew.setConfiguration('SynchronizedSealNo', this.containerInfo.sealNo)
      LocalStorageUtilsNew.setConfiguration('SynchronizedItemCount', this.containerInfo.itemCount)
      LocalStorageUtilsNew.setConfiguration('SynchronizedGrossWeight', this.containerInfo.grossWeight)
      LocalStorageUtilsNew.setConfiguration('SynchronizedCubage', this.containerInfo.cubage)
      LocalStorageUtilsNew.setConfiguration('SynchronizedHsCode', this.containerInfo.hsCode)
      this.close()
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
